import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TelefonbuchData } from '../data/telefonbuch-data';
import { CostCentre } from '../data/cost-centre';
import { BodyContent } from '../body/body-content';
import { Observable } from 'rxjs';
import { Person } from '../data/person';
import { FieldType } from '../types/field-type';

@Injectable({
  providedIn: 'root'
})
export class FieldService {
  private http = inject(HttpClient);

  controllerURL = '/api/fields';

  getSpeedikonRooms(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/rooms');
  }

  getMySpeedikonRooms(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/my-rooms');
  }

  getCostCentres(): Observable<CostCentre[]> {
    return this.http.get<CostCentre[]>(environment.apiUrl + this.controllerURL + '/dynamic/cost-centres');
  }

  getApplicationGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/application');
  }

  getBimedialGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/bimedial');
  }

  getCadGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/cad');
  }

  getConfluenceGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/confluence');
  }

  getFileserviceGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/fileservice');
  }

  getGeneralGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/general');
  }

  getItGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/it');
  }

  getJiraGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/jira');
  }

  getMCloudGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/mcloud');
  }

  getMusicMasterGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/music-master');
  }

  getProjectGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/project');
  }

  getRabbitGroups(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/rabbit');
  }

  getGroupSuggestions(): Observable<Record<FieldType, string[] | undefined>> {
    return this.http.get<Record<FieldType, string[] | undefined>>(environment.apiUrl + this.controllerURL + '/dynamic/group-suggestions');
  }

  getClients(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/clients');
  }

  getMyTelefonbuchData(): Observable<TelefonbuchData> {
    return this.http.get<TelefonbuchData>(environment.apiUrl + this.controllerURL + '/dynamic/my-telefonbuch-data');
  }

  getProductionUnits(): Observable<{ Bezeichnung: string; SYSID: string }[]> {
    return this.http.get<{ Bezeichnung: string; SYSID: string }[]>(environment.apiUrl + this.controllerURL + '/dynamic/production-units');
  }

  searchPerson(q: string, formFieldId: string): Observable<Person[]> {
    const params = new HttpParams()
      .append('q', q)
      .append('formFieldId', formFieldId);
    return this.http.get<Person[]>(environment.apiUrl + this.controllerURL + '/dynamic/person/search', { params });
  }

  searchAccount(q: string, formFieldId: string): Observable<string[]> {
    const params = new HttpParams()
      .append('q', q)
      .append('formFieldId', formFieldId);
    return this.http.get<string[]>(environment.apiUrl + this.controllerURL + '/dynamic/accounts/search', { params });
  }

  checkFile(body: BodyContent): Observable<void> {
    const headers = new HttpHeaders()
      .append('Content-Type', 'application/json');

    return this.http.post<void>(environment.apiUrl + this.controllerURL + '/dynamic/check-file', body, { headers });
  }
}
